import { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Products from './Products';
import ProductPrice from './ProductPrice';
import ProductPriceModal from './ProductPriceModal';
import FloatingActionButton from '../../common_components/FloatingActionButton';
import '../../../../custom.css';

const ProductProductPrice = () => {
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showProductPriceModal, setShowProductPriceModal] = useState(false);

    const handleProductClick = (product) => {
        setSelectedProduct(product);
    };

    const handleClearProductFilter = () => {
        setSelectedProduct(null);
    };

    const handleShowProductPriceModal = (product = null) => {
        setSelectedProduct(product);
        setShowProductPriceModal(true);
    };

    const handleCloseProductPriceModal = () => {
        setSelectedProduct(null);
        setShowProductPriceModal(false);
    };

    return (
        <Container>
            <Row>
                <Col md={6}>
                    <Products
                        onProductClick={handleProductClick}
                        clearProductFilter={handleClearProductFilter} />
                </Col>
                <Col md={6}>
                    <ProductPrice
                        product={selectedProduct}
                        clearProductFilter={handleClearProductFilter} />
                </Col>
            </Row>
            <FloatingActionButton
                actions={[
                    {
                        icon: 'bi-plus-square',
                        color: '#4b88a2',
                        handler: () => handleShowProductPriceModal(),
                        tooltip: 'Add Product Price',
                    }
                ]}
            />
            <ProductPriceModal
                show={showProductPriceModal}
                handleClose={handleCloseProductPriceModal}
                product={selectedProduct}
            />
        </Container>
    );
};

export default ProductProductPrice;
